import React from 'react'
import SideNav from './SideNav'

const WhatWeDo = () => {
  return (
    <div>
      <>
        <div className="page-header-what-we-do parallaxie">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="page-header-box">
                  <h1 className="text-anime-style-2" data-cursor="-opaque">
                    What We Do
                  </h1>
                  <div className="hero-btn wow fadeInUp" data-wow-delay="0.4s">
                    <a href="about-us" className="btn-default">About Us</a>
                    <a href="contact-us" className="btn-default btn-highlighted">Contact Us</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="page-service-single">
          <div className="container">
            <div className="row">
              <div className="col-lg-8">
                <div className="service-single-content">

                   

                  <div className="service-entry">
                    <p className="wow fadeInUp">
                      At <b>MeHome</b>, we design, build, and deliver exceptional spaces that elevate living. 
                      Every project is a reflection of who our clients are — their dreams, routines, and lifestyle choices. 
                      From idea to installation, we bring creativity and craftsmanship together to create spaces that inspire.
                    </p>

                    <h2 className="text-anime-style-2" data-cursor="-opaque">
                      Our <span>Core Expertise</span>
                    </h2>

                    <ul>
                      <li><b>Interior Design:</b> Creating beautiful, functional spaces tailored to individual lifestyles.</li>
                      <li><b>Construction & Renovation:</b> High-quality builds with precision and accountability.</li>
                      <li><b>Furniture & Custom Joinery:</b> Handcrafted furniture that blends aesthetics and utility.</li>
                      <li><b>Landscape Design:</b> Bringing life to outdoor spaces through balance and natural harmony.</li>
                      <li><b>Lighting & Décor:</b> Elegant lighting concepts and decor styling that define mood and atmosphere.</li>
                    </ul>
                  </div>

                  <div className="why-choose-content service-single-why-choose">
                    <div className="section-title">
                      <h2 className="text-anime-style-2" data-cursor="-opaque">
                        How <span>We Work</span>
                      </h2>
                    </div>

                    <div className="why-choose-item-list">
                      <div className="why-choose-item wow fadeInUp" data-wow-delay="0.4s">
                        <div className="icon-box">🧭</div>
                        <div className="why-choose-item-content">
                          <h3>Discovery & Planning</h3>
                          <p>
                            We begin by understanding your vision, lifestyle, and budget to create a clear, achievable design plan.
                          </p>
                        </div>
                      </div>

                      <div className="why-choose-item wow fadeInUp" data-wow-delay="0.6s">
                        <div className="icon-box">🧩</div>
                        <div className="why-choose-item-content">
                          <h3>Design & Conceptualization</h3>
                          <p>
                            Our creative team develops detailed layouts, color themes, and 3D visuals that bring your dream to life.
                          </p>
                        </div>
                      </div>

                      <div className="why-choose-item wow fadeInUp" data-wow-delay="0.8s">
                        <div className="icon-box">🏗️</div>
                        <div className="why-choose-item-content">
                          <h3>Execution & Construction</h3>
                          <p>
                            Skilled craftsmen, engineers, and project managers work seamlessly to ensure precise execution and timely delivery.
                          </p>
                        </div>
                      </div>

                      <div className="why-choose-item wow fadeInUp" data-wow-delay="1s">
                        <div className="icon-box">🎨</div>
                        <div className="why-choose-item-content">
                          <h3>Finishing & Styling</h3>
                          <p>
                            Every surface, fixture, and fabric is finished with finesse, giving your space the final touch of perfection.
                          </p>
                        </div>
                      </div>

                      <div className="why-choose-item wow fadeInUp" data-wow-delay="1.2s">
                        <div className="icon-box">🏡</div>
                        <div className="why-choose-item-content">
                          <h3>Delivery & Handover</h3>
                          <p>
                            We hand over spaces that are fully styled, functional, and ready to live in — on time, every time.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>

                   

                  <div className="service-single-faq">
                    <div className="section-title">
                      <h2 className="text-anime-style-2" data-cursor="-opaque">
                        Why <span> MeHome</span>
                      </h2>
                    </div>
                    <div className="wow fadeInUp" data-wow-delay="0.6s">
                      <ul>
                        <li><b>Experience That Matters:</b> Over 6+ years of proven excellence in design and construction.</li>
                        <li><b>Holistic Design Approach:</b> From vision to execution, all under one roof.</li>
                        <li><b>Quality Assurance:</b> Only premium materials, trusted vendors, and skilled professionals.</li>
                        <li><b>Client-Centric Philosophy:</b> Transparent communication and tailored solutions.</li>
                        <li><b>Passion for Perfection:</b> We design spaces that stand the test of time.</li>
                      </ul>
                    </div>
                  </div>

                </div>
              </div>

              <div className="col-lg-4">
                <SideNav />
              </div>
            </div>
          </div>
        </div>
      </>
    </div>
  )
}

export default WhatWeDo
